import React from 'react';
import classNames from 'classnames';
import { SectionProps } from '../utils/SectionProps';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const Attribution = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const outerClasses = classNames(
    'hero section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <title>MergeURL - Attribution Notice</title>
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <h1 className="mt-0 mb-16 text-color-primary reveal-from-bottom center-content" data-reveal-delay="200">
            Attribution Notice
            </h1>
            <div className="container-xs reveal-from-bottom" data-reveal-delay="200">
              <p className="center-content">Last updated: August 13, 2020</p>
              <p>This attribution notice holds the attributions for the images, design, software and any other thing used in the making of MergeURL.</p>

              <h3>Absurd Design</h3>
              <p>Wonderful illustrations and images used within this project.</p>
              <p>Link: <a href="https://absurd.design"><span className="text-color-primary">absurd.design</span></a></p>
              <p>Under Free License: <a href="https://absurd.design/license.html"><span className="text-color-primary">Free License</span></a></p>
              
              <h2>Contact Us</h2>
              <p>If you have any questions about this Attribution Notice, You can contact Us:</p>
              <p>By email: <a href="mailto:support@mergeurl.com"><span className="text-color-primary">support@mergeurl.com</span></a></p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

Attribution.propTypes = propTypes;
Attribution.defaultProps = defaultProps;

export default Attribution;
